export class Project {
    id: number;
    code: string;
    name: string;
    state: any;
}